(function () {
  if (window.RoydedTopCard) return;
  function wrap(button) {
    var card = document.createElement('div');
    card.className = button.className;
    card.dataset.value = button.dataset.value || '';
    while (button.firstChild) card.appendChild(button.firstChild);
    var name = card.querySelector('.rd3-bundle-picker__tee-label');
    var link = document.createElement('a');
    link.className = name.className;
    link.textContent = name.textContent;
    name.replaceWith(link);
    button.className = 'rd3-bundle-picker__select';
    card.appendChild(button);
    return card;
  }
  function update(card, selected, url, variantId) {
    card.dataset.selected = String(selected);
    var button = card.querySelector('.rd3-bundle-picker__select');
    button.setAttribute('aria-pressed', String(selected));
    var link = card.querySelector('.rd3-bundle-picker__tee-label');
    if (selected && url && variantId) {
      var target = new URL(url, window.location.origin);
      target.searchParams.set('variant', variantId);
      link.href = target.pathname + target.search;
      link.removeAttribute('tabindex');
    } else {
      link.removeAttribute('href');
      link.setAttribute('tabindex', '-1');
    }
  }
  window.RoydedTopCard = { wrap: wrap, update: update };
})();
